<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Daftar Gaji</li>
        <li class="breadcrumb-item">
          <a href="#/final-gaji-baru">Generate Gaji</a>
        </li>
      </ol>
    </nav>
    <h5 class="content-block">Daftar Gaji update</h5>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxTabPanel
          id="tabpanel"
          :data-source="tabSource"
          v-model:selected-index="tabPanelIndex"
          :loop="loop"
          :animation-enabled="animationEnabled"
          :swipe-enabled="swipeEnabled"
          item-title-template="title"
          @titleClick="tabTitleClick"
        >
          <template #title="{ data: item }">
            <span class="tab-panel-title">{{ item.text }}</span>
          </template>

          <template #tDireksi>
            <DxDataGrid
              ref="gridRefDireksi"
              id="gridTDireksi"
              :data-source="dataSourceDireksi"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefDireksi')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :focused-row-index="0"
              @row-updating="onRowUpdating($event, 'gridRefDireksi')"
            >
              <DxFilterRow :visible="true" :apply-filter="currentFilter" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <!-- <DxEditing
                :allow-updating="true"
                :allow-deleting="false"
                :allow-adding="false"
                mode="row"
              /> -->
              <DxEditing
                :allow-updating="can('gaji-update')"
                :allow-deleting="can('gaji-del')"
                :allow-adding="can('gaji-create')"
                mode="row"
              />

              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefDireksi')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <DxSelection mode="multiple" />
              <DxColumnFixing :enabled="true" />

              <DxColumn
                type="buttons"
                :fixed="true"
                fixed-position="right"
                :allow-hiding="false"
              >
                <DxButtonDatagrid name="edit" />
                <DxButtonDatagrid
                  hint="Detail Pegawai"
                  icon="search"
                  :visible="true"
                  @click="detailPegawai"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="status_gaji"
                caption="Status Gaji"
                cell-template="statusTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <template #statusTemplate="{ data }">
                <!-- {{ formatStatusGaji(data.text) }} -->
                <DxButton
                  :icon="formatStatusGaji('icon', { data })"
                  :type="formatStatusGaji('type', { data })"
                  @click="approveClick({ data })"
                />
              </template>
              <DxColumn
                class="noteditable"
                caption="#"
                data-field="created_at"
                cell-template="numberingTemplate"
                :allow-filtering="false"
                :allow-sorting="false"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <template #numberingTemplate="{ data }">
                {{
                  numberingPageNumber * numberingPageSize + data.rowIndex + 1
                }}
              </template>
              <template #currencyTemplate="{ data }">
                {{ formatNumber(data.value) }}
              </template>
              <DxColumn
                class="noteditable"
                data-field="pegawai.nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable"
                data-field="pegawai.nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                sort-order="desc"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="golongan_id"
                caption="Gol."
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="pegawai.status_ptkp"
                caption="Status PTKP"
                :allow-hiding="false"
              />
              <!-- <DxColumn
                class="noteditable"
                data-field="riwayatGolongan"
                caption="Masa Kerja"
                :calculate-display-value="calculateDisplayMK"
                :calculate-filter-expression="calculateFilterMK"
                :allow-hiding="false"
              >
              </DxColumn> -->
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.jabatan_id"
                caption="Jabatan"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="jabatanSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.cabang_id"
                caption="Cabang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="cabangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.unit_id"
                caption="Unit"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="unitSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.bagian_id"
                caption="Bagian"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="bagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.sub_bagian_id"
                caption="Sub Bagian"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="subBagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.bidang_id"
                caption="Bidang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="bidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.sub_bidang_id"
                caption="Sub Bidang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="subBidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.seksi_id"
                caption="Seksi"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="seksiSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn caption="Jabatan PLT">
                <DxColumn
                  data-field="riwayatPlt.jabatan_id"
                  caption="Jabatan PLT"
                >
                  <DxLookup
                    :data-source="jabatanSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  data-field="riwayatPlt.cabang_id"
                  caption="Cabang PLT"
                >
                  <DxLookup
                    :data-source="cabangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn data-field="riwayatPlt.unit_id" caption="Unit PLT">
                  <DxLookup
                    :data-source="unitSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  data-field="riwayatPlt.bagian_id"
                  caption="Bagian PLT"
                >
                  <DxLookup
                    :data-source="bagianSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  data-field="riwayatPlt.sub_bagian_id"
                  caption="Sub Bagian PLT"
                >
                  <DxLookup
                    :data-source="subBagianSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  data-field="riwayatPlt.bidang_id"
                  caption="Bidang PLT"
                >
                  <DxLookup
                    :data-source="bidangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  data-field="riwayatPlt.sub_bidang_id"
                  caption="Sub Bidang PLT"
                >
                  <DxLookup
                    :data-source="subBidangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
              </DxColumn>

              <DxColumn
                data-field="gaji_pokok"
                caption="Gaji Pokok"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="tun_perusahaan"
                caption="Tunj. Perusahaan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="tun_jabatan"
                caption="Tunj. Jabatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="tun_kemahalan"
                caption="Tunj. Kemahalan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="tun_air"
                caption="Tunj. Air"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="tun_transport"
                caption="Tunj. Transport"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="tun_pangan"
                caption="Tunj. Pangan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="tun_kesehatan"
                caption="Tunj. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="absenBulan.tidak_hadir"
                caption="Jml Tdk Hadir"
                class="noteditable"
                :allow-hiding="false"
              />
              <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
              <DxColumn
                class="noteditable"
                data-field="pot_5_persen"
                caption="Pot. Tdk Hadir"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="jml_bruto"
                caption="Jml Bruto"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="tun_pph"
                caption="Tunj. PPH"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="pot_kesehatan"
                caption="Pot. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="pot_bpjs_tk_tiga_program"
                caption="Pot. BPJS TK 3 Program"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="pot_bpjs_tk_empat_program"
                caption="Pot. BPJS TK 4 Program"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="pot_pensiun"
                caption="Pot. Pensiun Jiwasraya"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="pot_pph"
                caption="Pot. PPH"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="edited_by_user"
                caption="Ket."
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="editedSource"
                  value-expr="val"
                  display-expr="nama"
              /></DxColumn>

              <DxSummary>
                <DxTotalItem
                  column="created_at"
                  summary-type="count"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="gaji_pokok"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_perusahaan"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="tun_jabatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kemahalan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_air"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_transport"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pangan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="absenBulan.tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <!-- <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                /> -->
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_tiga_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_empat_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pensiun"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <template #mkTemplate="{ data }">
                {{ formatMasaKerja(data.text) + " tahun" }}
                <!-- {{ data.text }} -->
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
            <DxButton
              v-if="can('gaji-approve')"
              @click="approveAllDialog('tDireksi')"
              text="approve semua"
              type="danger"
              class="validate"
            />
          </template>
          <template #tTetap>
            <DxDataGrid
              ref="gridRefTetap"
              id="gridTetap"
              :data-source="dataSourceTetap"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefTetap')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :focused-row-index="0"
              @row-updating="onRowUpdating($event, 'gridRefTetap')"
            >
              <DxFilterRow :visible="true" :apply-filter="currentFilter" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <DxEditing
                :allow-updating="can('gaji-update')"
                :allow-deleting="can('gaji-del')"
                :allow-adding="can('gaji-create')"
                mode="row"
              />
              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefTetap')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <DxSelection mode="multiple" />
              <DxColumnFixing :enabled="true" />
              <DxColumn
                type="buttons"
                :fixed="true"
                fixed-position="right"
                :allow-hiding="false"
              >
                <DxButtonDatagrid name="edit" />
                <DxButtonDatagrid
                  hint="Detail Pegawai"
                  icon="search"
                  :visible="true"
                  @click="detailPegawai"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="status_gaji"
                caption="Status Gaji"
                cell-template="statusTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                caption="#"
                data-field="created_at"
                cell-template="numberingTemplate"
                :allow-filtering="false"
                :allow-sorting="false"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <template #numberingTemplate="{ data }">
                {{
                  numberingPageNumber * numberingPageSize + data.rowIndex + 1
                }}
              </template>
              <template #currencyTemplate="{ data }">
                {{ formatNumber(data.value) }}
              </template>
              <template #statusTemplate="{ data }">
                <!-- {{ formatStatusGaji(data.text) }} -->
                <DxButton
                  :icon="formatStatusGaji('icon', { data })"
                  :type="formatStatusGaji('type', { data })"
                  @click="approveClick({ data })"
                />
              </template>
              <DxColumn
                class="noteditable"
                data-field="pegawai.nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable"
                data-field="pegawai.nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                sort-order="desc"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="golongan_id"
                caption="Gol."
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <!-- <DxColumn
                class="noteditable"
                data-field="riwayatGolongan.golongan_id"
                caption="Gol."
              >
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn> -->
              <DxColumn
                class="noteditable"
                data-field="pegawai.status_ptkp"
                caption="Status PTKP"
                :allow-hiding="false"
              />
              <!-- <DxColumn
                class="noteditable"
                data-field="riwayatGolongan"
                caption="Masa Kerja"
                :calculate-display-value="calculateDisplayMK"
                :calculate-filter-expression="calculateFilterMK"
              >
              </DxColumn> -->
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.jabatan_id"
                caption="Jabatan"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="jabatanSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.cabang_id"
                caption="Cabang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="cabangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.unit_id"
                caption="Unit"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="unitSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.bagian_id"
                caption="Bagian"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="bagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.sub_bagian_id"
                caption="Sub Bagian"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="subBagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.bidang_id"
                caption="Bidang"
              >
                <DxLookup
                  :data-source="bidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.sub_bidang_id"
                caption="Sub Bidang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="subBidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.seksi_id"
                caption="Seksi"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="seksiSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn caption="Jabatan PLT">
                <DxColumn
                  data-field="riwayatPlt.jabatan_id"
                  caption="Jabatan PLT"
                >
                  <DxLookup
                    :data-source="jabatanSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  data-field="riwayatPlt.cabang_id"
                  caption="Cabang PLT"
                >
                  <DxLookup
                    :data-source="cabangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn data-field="riwayatPlt.unit_id" caption="Unit PLT">
                  <DxLookup
                    :data-source="unitSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  data-field="riwayatPlt.bagian_id"
                  caption="Bagian PLT"
                >
                  <DxLookup
                    :data-source="bagianSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  data-field="riwayatPlt.sub_bagian_id"
                  caption="Sub Bagian PLT"
                >
                  <DxLookup
                    :data-source="subBagianSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  data-field="riwayatPlt.bidang_id"
                  caption="Bidang PLT"
                >
                  <DxLookup
                    :data-source="bidangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  data-field="riwayatPlt.sub_bidang_id"
                  caption="Sub Bidang PLT"
                >
                  <DxLookup
                    :data-source="subBidangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
              </DxColumn>
              <DxColumn
                data-field="gaji_pokok"
                caption="Gaji Pokok"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="tun_perusahaan"
                caption="Tunj. Perusahaan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="tun_jabatan"
                caption="Tunj. Jabatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="tun_kemahalan"
                caption="Tunj. Kemahalan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="tun_air"
                caption="Tunj. Air"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="tun_transport"
                caption="Tunj. Transport"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="tun_pangan"
                caption="Tunj. Pangan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="tun_kesehatan"
                caption="Tunj. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="absenBulan.tidak_hadir"
                caption="Jml Tdk Hadir"
                class="noteditable"
                :allow-hiding="false"
              />
              <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
              <DxColumn
                class="noteditable"
                data-field="pot_5_persen"
                caption="Pot. Tdk Hadir"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="jml_bruto"
                caption="Jml Bruto"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="tun_pph"
                caption="Tunj. PPH"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="pot_kesehatan"
                caption="Pot. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="pot_bpjs_tk_tiga_program"
                caption="Pot. BPJS TK 3 Program"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="pot_bpjs_tk_empat_program"
                caption="Pot. BPJS TK 4 Program"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="pot_pensiun"
                caption="Pot. Pensiun Jiwasraya"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="pot_pph"
                caption="Pot. PPH"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="edited_by_user"
                caption="Ket."
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="editedSource"
                  value-expr="val"
                  display-expr="nama"
              /></DxColumn>
              <DxSummary>
                <DxTotalItem
                  column="created_at"
                  summary-type="count"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="gaji_pokok"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_perusahaan"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="tun_jabatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kemahalan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_air"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_transport"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pangan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="absenBulan.tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <!-- <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                /> -->
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_tiga_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_empat_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pensiun"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <template #mkTemplate="{ data }">
                {{ formatMasaKerja(data.text) + " tahun" }}
                <!-- {{ data.text }} -->
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
            <DxButton
              v-if="can('gaji-approve')"
              @click="approveAllDialog('tTetap')"
              text="approve semua"
              type="danger"
              class="validate"
            />
          </template>
          <template #tHonor>
            <DxDataGrid
              ref="gridRefHonor"
              id="gridHonor"
              :data-source="dataSourceHonor"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefHonor')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :focused-row-index="0"
              @row-updating="onRowUpdating($event, 'gridRefHonor')"
            >
              <DxFilterRow :visible="true" :apply-filter="currentFilter" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <DxEditing
                :allow-updating="can('gaji-update')"
                :allow-deleting="can('gaji-del')"
                :allow-adding="can('gaji-create')"
                mode="row"
              />
              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefHonor')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <DxSelection mode="multiple" />
              <DxColumnFixing :enabled="true" />
              <DxColumn
                type="buttons"
                :fixed="true"
                fixed-position="right"
                :allow-hiding="false"
              >
                <DxButtonDatagrid name="edit" />
                <DxButtonDatagrid
                  hint="Detail Pegawai"
                  icon="search"
                  :visible="true"
                  @click="detailPegawai"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="status_gaji"
                caption="Status Gaji"
                cell-template="statusTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <template #statusTemplate="{ data }">
                <!-- {{ formatStatusGaji(data.text) }} -->
                <DxButton
                  :icon="formatStatusGaji('icon', { data })"
                  :type="formatStatusGaji('type', { data })"
                  @click="approveClick({ data })"
                />
              </template>
              <DxColumn
                class="noteditable"
                caption="#"
                data-field="created_at"
                cell-template="numberingTemplate"
                :allow-filtering="false"
                :allow-sorting="false"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <template #numberingTemplate="{ data }">
                {{
                  numberingPageNumber * numberingPageSize + data.rowIndex + 1
                }}
              </template>
              <template #currencyTemplate="{ data }">
                {{ formatNumber(data.value) }}
              </template>
              <DxColumn
                class="noteditable"
                data-field="pegawai.nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable"
                data-field="pegawai.nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                sort-order="desc"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="golongan_id"
                caption="Gol."
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.jabatan_id"
                caption="Jabatan"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="jabatanSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.cabang_id"
                caption="Cabang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="cabangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.unit_id"
                caption="Unit"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="unitSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.bagian_id"
                caption="Bagian"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="bagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.sub_bagian_id"
                caption="Sub Bagian"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="subBagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.bidang_id"
                caption="Bidang"
              >
                <DxLookup
                  :data-source="bidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.sub_bidang_id"
                caption="Sub Bidang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="subBidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.seksi_id"
                caption="Seksi"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="seksiSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="pegawai.tgl_mulai_bekerja"
                caption="TMT Kontrak"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="pegawai.tgl_mulai_bekerja"
                caption="Masa Kerja"
                :calculate-cell-value="calculateCellMK"
                data-type="string"
              ></DxColumn>

              <!-- <DxColumn
                class="noteditable"
                data-field="riwayatGolongan"
                caption="Masa Kerja"
                :calculate-display-value="calculateDisplayMK"
                :calculate-filter-expression="calculateFilterMK"
                :allow-hiding="false"
              >
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatGolongan"
                caption="Masa Kerja"
                :calculate-display-value="calculateDisplayMK"
                :allow-hiding="false"
              /> -->
              <DxColumn
                data-field="honor_umk_jml"
                caption="Honor (UMK)"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />

              <DxColumn
                data-field="kenaikan_masa_kerja"
                caption="Kenaikan Masa Kerja"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="tun_kesehatan"
                caption="Tunj. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="absenBulan.tidak_hadir"
                caption="Jml Tdk Hadir"
                class="noteditable"
                :allow-hiding="false"
              />

              <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
              <DxColumn
                class="noteditable"
                data-field="pot_5_persen"
                caption="Pot. Tdk Hadir"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="jml_bruto"
                caption="Jml Bruto"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="pot_kesehatan"
                caption="Pot. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="pot_bpjs_tk_dua_persen"
                caption="Pot. BPJS TK 2%"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="edited_by_user"
                caption="Ket."
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="editedSource"
                  value-expr="val"
                  display-expr="nama"
              /></DxColumn>

              <DxSummary>
                <DxTotalItem
                  column="created_at"
                  summary-type="count"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="honor_umk_jml"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="kenaikan_masa_kerja"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="absenBulan.tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <!-- <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                /> -->
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_dua_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <template #mkTemplate="{ data }">
                {{ formatMasaKerja(data.text) + " tahun" }}
                <!-- {{ data.text }} -->
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
            <DxButton
              v-if="can('gaji-approve')"
              @click="approveAllDialog('tHonor')"
              text="approve semua"
              type="danger"
              class="validate"
            />
          </template>
          <template #tKontrak>
            <DxDataGrid
              ref="gridRefKontrak"
              :data-source="dataSourceKontrak"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefKontrak')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :focused-row-index="0"
              @row-updating="onRowUpdating($event, 'gridRefKontrak')"
            >
              <DxFilterRow :visible="true" :apply-filter="currentFilter" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" :allow-export-selected-data="true" />
              <DxEditing
                :allow-updating="can('gaji-update')"
                :allow-deleting="can('gaji-del')"
                :allow-adding="can('gaji-create')"
                mode="row"
              />
              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefKontrak')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <DxSelection mode="multiple" />
              <DxColumnFixing :enabled="true" />
              <DxColumn
                type="buttons"
                :fixed="true"
                fixed-position="right"
                :allow-hiding="false"
              >
                <DxButtonDatagrid name="edit" />
                <DxButtonDatagrid
                  hint="Detail Pegawai"
                  icon="search"
                  :visible="true"
                  @click="detailPegawai"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="status_gaji"
                caption="Status Gaji"
                cell-template="statusTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <template #statusTemplate="{ data }">
                <!-- {{ formatStatusGaji(data.text) }} -->
                <DxButton
                  :icon="formatStatusGaji('icon', { data })"
                  :type="formatStatusGaji('type', { data })"
                  @click="approveClick({ data })"
                />
              </template>
              <DxColumn
                class="noteditable"
                caption="#"
                data-field="created_at"
                cell-template="numberingTemplate"
                :allow-filtering="false"
                :allow-sorting="false"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <template #numberingTemplate="{ data }">
                {{
                  numberingPageNumber * numberingPageSize + data.rowIndex + 1
                }}
              </template>
              <template #currencyTemplate="{ data }">
                {{ formatNumber(data.value) }}
              </template>
              <DxColumn
                class="noteditable"
                data-field="pegawai.nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable"
                data-field="pegawai.nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                sort-order="desc"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="golongan_id"
                caption="Gol."
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <!-- <DxColumn
                class="noteditable"
                data-field="riwayatGolongan"
                caption="Masa Kerja"
                :calculate-display-value="calculateDisplayMK"
                :calculate-filter-expression="calculateFilterMK"
                :allow-hiding="false"
              >
              </DxColumn> -->
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.jabatan_id"
                caption="Jabatan"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="jabatanSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.cabang_id"
                caption="Cabang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="cabangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.unit_id"
                caption="Unit"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="unitSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.bagian_id"
                caption="Bagian"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="bagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.sub_bagian_id"
                caption="Sub Bagian"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="subBagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-field="riwayatPekerjaan.bidang_id"
                caption="Bidang"
              >
                <DxLookup
                  :data-source="bidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.sub_bidang_id"
                caption="Sub Bidang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="subBidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-field="riwayatPekerjaan.seksi_id"
                caption="Seksi"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="seksiSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="pegawai.tgl_mulai_bekerja"
                caption="TMT Kontrak"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable"
                data-field="pegawai.tgl_mulai_bekerja"
                caption="Masa Kerja"
                :calculate-cell-value="calculateCellMK"
                data-type="string"
              ></DxColumn>

              <DxColumn
                data-field="honor_umk_jml"
                caption="Honor (UMK)"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="kenaikan_masa_kerja"
                caption="Kenaikan Masa Kerja"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="tun_kesehatan"
                caption="Tunj. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-field="absenBulan.tidak_hadir"
                caption="Jml Tdk Hadir"
                class="noteditable"
                :allow-hiding="false"
              />
              <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
              <DxColumn
                class="noteditable"
                data-field="pot_5_persen"
                caption="Pot. Tdk Hadir"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="tun_bpjs_tk_satu_sembilanbelas_persen"
                caption="Tunj. BPJS TK 1.19%"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="jml_bruto"
                caption="Jml Bruto"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="pot_kesehatan"
                caption="Pot. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="pot_bpjs_tk_satu_sembilanbelas_persen"
                caption="Pot. BPJS TK 1.19%"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable"
                data-field="edited_by_user"
                caption="Ket."
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="editedSource"
                  value-expr="val"
                  display-expr="nama"
              /></DxColumn>

              <DxSummary>
                <DxTotalItem
                  column="created_at"
                  summary-type="count"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="honor_umk_jml"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="kenaikan_masa_kerja"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="absenBulan.tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <!-- <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                /> -->
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_bpjs_tk_satu_sembilanbelas_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_satu_sembilanbelas_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>
              <template #mkTemplate="{ data }">
                {{ formatMasaKerja(data.text) + " tahun" }}
                <!-- {{ data.text }} -->
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
            <DxButton
              v-if="can('gaji-approve')"
              @click="approveAllDialog('tKontrak')"
              text="approve semua"
              type="danger"
              class="validate"
            />
          </template>
        </DxTabPanel>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>

<script>
import router from "@/router";
import can from "@/haspermission";
import DxTabPanel from "devextreme-vue/tab-panel";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import DxButton from "devextreme-vue/button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxToolbar,
  DxItem,
  DxSummary,
  DxTotalItem,
  DxButton as DxButtonDatagrid,
  DxColumnChooser,
  DxColumnChooserSearch,
  DxColumnChooserSelection,
  DxPosition,
} from "devextreme-vue/data-grid";
// import { toHandlerKey } from "vue";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { DateTime } from "luxon";
import _ from "lodash";
import { confirm } from "devextreme/ui/dialog";
import notify from "devextreme/ui/notify";
import axios from "axios";
import api from "@/api";
import { API_BASE_URL } from "@/global-constants";
import { ODATA_BASE_URL } from "@/global-constants";

import { useGolonganStore } from "@/stores/GolonganStore";
import { useJabatanStore } from "@/stores/JabatanStore";
import { useBagianStore } from "@/stores/BagianStore";
import { useBidangStore } from "@/stores/BidangStore";
import { useSubBagianStore } from "@/stores/SubBagianStore";
import { useSubBidangStore } from "@/stores/SubBidangStore";
import { useSeksiStore } from "@/stores/SeksiStore";
import { useCabangStore } from "@/stores/CabangStore";
import { useUnitStore } from "@/stores/UnitStore";

const tabSource = [
  {
    id: 1,
    text: "Direksi",
    template: "tDireksi",
  },
  {
    id: 2,
    text: "Pegawai Tetap",
    template: "tTetap",
  },
  {
    id: 3,
    text: "Pekerja Honor",
    template: "tHonor",
  },
  {
    id: 4,
    text: "Pekerja Kontrak",
    template: "tKontrak",
  },
];

function hasFilterNestedTable(str) {
  return (
    _.includes(str, "/") ||
    _.includes(str, "[") ||
    _.includes(str, "]") ||
    _.includes(str, "riwayatPekerjaan/") ||
    _.includes(str, "riwayatGolongan/") ||
    _.includes(str, "pegawai/")
  );
}

function convertFilterPegawai(filter) {
  var searchTerm = (filter.match(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/
  ) || [])[1];
  var replacedString = filter.replace(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nama),'${searchTerm}'))`
  );

  var searchTermNik = (replacedString.match(
    /contains\(tolower\(pegawai\/nik\),'([^']+)'/
  ) || [])[1];
  var replacedStringNik = replacedString;

  replacedStringNik = replacedString.replace(
    /contains\(tolower\(pegawai\/nik\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nik),'${searchTermNik}'))`
  );

  return replacedStringNik;
}

function convertFilter(filter, regVar) {
  // const regex = new RegExp(`${regVar}\/(\\w+) eq (\\d+)`, "g"); //utk detect riwayatPekerjaan/cabang_id eq 2
  const regex = new RegExp(`${regVar}/(\\w+) eq (\\d+)`, "g");
  const outputString = filter.replace(regex, (match, p1, p2) => {
    return `${regVar}/any(s:s/${p1} eq ${p2})`;
  });
  return outputString;
}

const dataSourceDireksi = new DataSource({
  store: new ODataStore({
    url: `${ODATA_BASE_URL}/PegawaiGajiFinals`,
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
      if (e.method == "PATCH") {
        e.payload.edited_by_user = true;
      }

      if (hasFilterNestedTable(e.params.$filter)) {
        e.params.$filter = convertFilter(e.params.$filter, "riwayatGolongan");
        e.params.$filter = convertFilter(e.params.$filter, "riwayatPekerjaan");
        e.params.$filter = convertFilter(e.params.$filter, "riwayatPlt");
        e.params.$filter = convertFilterPegawai(e.params.$filter);
      }
    },
  }),
  expand: ["riwayatPekerjaan,riwayatGolongan,pegawai,absenBulan,riwayatPlt"],
  filter: [
    ["proyeksi", false],
    [
      ["gaji_skema_id", 1],
      "or",
      ["gaji_skema_id", 2],
      "or",
      ["gaji_skema_id", 3],
    ],
  ], //FIXME: kemgunkinan error, karena pegawai direksi bisa aja punya banyak gaji_skema_id,
  //FIXME: perbaiki jadi where pegawai_status_id = direksi dari riwayatPekerjaan
});

const dataSourceTetap = new DataSource({
  store: new ODataStore({
    url: `${ODATA_BASE_URL}/PegawaiGajiFinals`,
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
      if (e.method == "PATCH") {
        e.payload.edited_by_user = true;
      }
      if (hasFilterNestedTable(e.params.$filter)) {
        e.params.$filter = convertFilter(e.params.$filter, "riwayatPekerjaan");
        e.params.$filter = convertFilter(e.params.$filter, "riwayatPlt");
        e.params.$filter = convertFilterPegawai(e.params.$filter);
      }
    },
  }),
  expand: ["riwayatPekerjaan,pegawai,absenBulan,riwayatPlt"],
  // filter: [["gaji_skema_id", 3], "and", ["status_gaji", 0]],
  filter: [
    ["proyeksi", false],
    [["gaji_skema_id", 4], "or", ["gaji_skema_id", 5]],
  ], //FIXME: kemgunkinan error, karena pegawai tetap bisa aja punya banyak gaji_skema_id,
  //FIXME: perbaiki jadi where pegawai_status_id = tetap dari riwayatPekerjaan
});

const dataSourceHonor = new DataSource({
  store: new ODataStore({
    url: `${ODATA_BASE_URL}/PegawaiGajiFinals`,
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
      if (e.method == "PATCH") {
        e.payload.edited_by_user = true;
      }

      if (hasFilterNestedTable(e.params.$filter)) {
        e.params.$filter = convertFilter(e.params.$filter, "riwayatGolongan");
        e.params.$filter = convertFilter(e.params.$filter, "riwayatPekerjaan");
        e.params.$filter = convertFilter(e.params.$filter, "riwayatPlt");
        e.params.$filter = convertFilterPegawai(e.params.$filter);
      }
    },
  }),
  expand: ["riwayatPekerjaan,riwayatGolongan,pegawai,absenBulan,riwayatPlt"],
  filter: [
    ["proyeksi", false],
    // ["gaji_skema_id", 1],
    [["gaji_skema_id", 6], "or", ["gaji_skema_id", 7]],
  ], //FIXME: kemgunkinan error, karena pekerja honor bisa aja punya banyak gaji_skema_id,
  //FIXME: perbaiki jadi where pegawai_status_id = honor dari riwayatPekerjaan
});

const dataSourceKontrak = new DataSource({
  store: new ODataStore({
    url: `${ODATA_BASE_URL}/PegawaiGajiFinals`,
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
      if (e.method == "PATCH") {
        e.payload.edited_by_user = true;
      }

      if (hasFilterNestedTable(e.params.$filter)) {
        e.params.$filter = convertFilter(e.params.$filter, "riwayatGolongan");
        e.params.$filter = convertFilter(e.params.$filter, "riwayatPekerjaan");
        e.params.$filter = convertFilter(e.params.$filter, "riwayatPlt");
        e.params.$filter = convertFilterPegawai(e.params.$filter);
      }
    },
  }),
  expand: ["riwayatPekerjaan,riwayatGolongan,pegawai,absenBulan,riwayatPlt"],
  filter: [
    ["proyeksi", false],
    // [["gaji_skema_id", 2], "or", ["gaji_skema_id", 8]],
    [["gaji_skema_id", 8], "or", ["gaji_skema_id", 9]],
  ], //FIXME: kemgunkinan error, karena Pekerja kontrak bisa aja punya banyak gaji_skema_id,
  //FIXME: perbaiki jadi where pegawai_status_id = kontrak dari riwayatPekerjaan
});

export default {
  components: {
    DxTabPanel,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxColumnFixing,
    DxSelection,
    DxExport,
    DxToolbar,
    DxItem,
    DxSummary,
    DxTotalItem,
    DxButton,
    DxButtonDatagrid,
    DxColumnChooser,
    DxColumnChooserSearch,
    DxColumnChooserSelection,
    DxPosition,
    // confirm,
  },
  setup() {
    const golonganStore = useGolonganStore();
    const jabatanStore = useJabatanStore();
    const bagianStore = useBagianStore();
    const bidangStore = useBidangStore();
    const subBagianStore = useSubBagianStore();
    const subBidangStore = useSubBidangStore();
    const seksiStore = useSeksiStore();
    const cabangStore = useCabangStore();
    const unitStore = useUnitStore();

    return {
      golonganStore,
      jabatanStore,
      bagianStore,
      bidangStore,
      subBagianStore,
      subBidangStore,
      seksiStore,
      cabangStore,
      unitStore,
    };
  },

  data() {
    return {
      mode: "select",
      searchEnabled: true,
      allowSelectAll: true,
      selectByClick: true,
      recursive: true,
      editorOptions: { placeholder: "Search column" },

      cabangSource: null,
      unitSource: null,
      jabatanSource: null,
      bagianSource: null,
      bidangSource: null,
      subBagianSource: null,
      subBidangSource: null,
      golonganSource: null,
      seksiSource: null,

      pegawaiGajiDetailSource: new ODataStore({
        url: `${ODATA_BASE_URL}/PegawaiGajiDetails`,
        key: "id",
      }),
      pegawaiSource: new ODataStore({
        url: `${ODATA_BASE_URL}/SimpegPegawais`,
        key: "id",
        version: 4,
        beforeSend: function (e) {
          e.headers = {
            "odata-version": "4.0",
          };
        },
      }),
      router: router,
      statusButtonIcon: null,
      statusButtonType: null,
      numberingPageSize: 10,
      numberingPageNumber: 0,
      dataSourceTetap: dataSourceTetap,
      dataSourceHonor: dataSourceHonor,
      dataSourceKontrak: dataSourceKontrak,
      dataSourceDireksi: dataSourceDireksi,
      tabPanelIndex: 0,
      loop: false,
      animationEnabled: true,
      swipeEnabled: false,
      tabSource: tabSource,
      editedSource: [
        { val: true, nama: "Diedit user" },
        { val: false, nama: "Dibuat sistem" },
      ],

      filterValue: "",

      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      calculateFilterMK: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        if (selectedFilterOperation === "contains" && target == "filterRow") {
          const currentDate = DateTime.now();
          const mkDate = currentDate.minus({ years: filterValue });
          var filterExpression = [
            "year(" +
              this.dataField +
              ") ge " +
              mkDate.year +
              " and " +
              "year(" +
              this.dataField +
              ") le " +
              currentDate.year,
          ];

          return filterExpression;
        }
      },
      filterOperations: ["=", "<>", ">", "<", "between"],
      calculateFilterExpression: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        let column = this;
        if (selectedFilterOperation === "=" && target == "filterRow") {
          let bulan = filterValue.getMonth() + 1;
          var filterExpression = [
            "month(" +
              column.dataField +
              ") eq " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterRow") {
          //notequal
          let bulan = filterValue.getMonth() + 1;
          var filterExpression2 = [
            "month(" +
              column.dataField +
              ") ne " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") ne " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression2;
        }
        if (selectedFilterOperation === "<" && target == "filterRow") {
          //less than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression3 = [
            "year(" +
              column.dataField +
              ") lt " +
              filterValue.getFullYear().toString() +
              " or (year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString() +
              " and month(" +
              column.dataField +
              ") lt " +
              bulan +
              ")",
          ];
          return filterExpression3;
        }
        if (selectedFilterOperation === ">" && target == "filterRow") {
          //greater than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression4 = [
            "year(" +
              column.dataField +
              ") gt " +
              filterValue.getFullYear().toString() +
              " or (year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString() +
              " and month(" +
              column.dataField +
              ") gt " +
              bulan +
              ")",
          ];
          return filterExpression4;
        }

        if (selectedFilterOperation === "between" && target == "filterRow") {
          // (year(Date) eq 2022 and month(Date) ge 5) or (year(Date) eq 2023 and month(Date) le 6)
          let bulan1 = filterValue[0].getMonth() + 1;
          let bulan2 = filterValue[1].getMonth() + 1;

          var filterExpression5 = [
            "month(" +
              column.dataField +
              ") ge " +
              bulan1 +
              " and year(" +
              column.dataField +
              ") ge " +
              filterValue[0].getFullYear() +
              " and " +
              "month(" +
              column.dataField +
              ") le " +
              bulan2 +
              " and year(" +
              column.dataField +
              ") le " +
              filterValue[1].getFullYear(),
          ];
          return filterExpression5;
        }

        // Invokes the default filtering behavior
        return column.defaultCalculateFilterExpression(arguments);
      },
    };
  },
  async mounted() {
    this.golonganSource = await this.golonganStore.get();
    this.jabatanSource = await this.jabatanStore.get();
    this.bagianSource = await this.bagianStore.get();
    this.bidangSource = await this.bidangStore.get();
    this.subBagianSource = await this.subBagianStore.get();
    this.subBidangSource = await this.subBidangStore.get();
    this.seksiSource = await this.seksiStore.get();
    this.cabangSource = await this.cabangStore.get();
    this.unitSource = await this.unitStore.get();
  },
  methods: {
    calculateCellMK(e) {
      //TODO nyari masa kerja bukan dari tgl sekarang, melainkan tgl pembuatan gaji
      const today = DateTime.fromISO(e.tgl_gaji);
      const tglMulaiKerja = DateTime.fromISO(e.pegawai.tgl_mulai_bekerja);

      const month = tglMulaiKerja.month + 1; // Months are zero-based, so add 1
      const year = tglMulaiKerja.year;

      var tglMk;
      if ((month >= 11 && month <= 12) || (month >= 1 && month <= 4)) {
        // If the month is between November and April (inclusive), set the date to April 1st
        tglMk = DateTime.fromObject({ year: year, month: 4, day: 1 });
      } else if (month >= 3 && month <= 10) {
        // If the month is between March and October (inclusive), set the date to October 1st
        tglMk = DateTime.fromObject({ year: year, month: 10, day: 1 });
      } else {
        // Handle other cases as needed
        tglMk = tglMulaiKerja;
      }
      return Math.floor(today.diff(tglMk, "years").years);
    },

    can,
    refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },
    detailPegawai(e) {
      // this.$router.push({
      //   name: "simpeg-pegawai-detail",
      //   query: { id: e.row.data.pegawai_id },
      // });
      const url = this.$router.resolve({
        name: "simpeg-pegawai-detail",
        query: { id: e.row.data.pegawai_id },
      }).href;
      window.open(url, "_blank");
    },
    async onRowUpdating(e, ref) {
      // const originalData = Object.assign({}, e.oldData);
      e.cancel = true;
      var re = await this.saveEditedDataToOData(e.key, e.newData, e.oldData);
      if (re.status) {
        e.component.cancelEditData();
        // var instance = this.$refs[ref].instance;
        this.$refs[ref].instance.cancelEditData();

        //update column
        var rowIndex = e.component.getRowIndexByKey(e.key);

        for (const columnName in e.newData) {
          const columnValue = e.newData[columnName];
          e.component.cellValue(rowIndex, columnName, columnValue);
          // instance.cellValue(rowIndex, columnName, columnValue);
        }
        // var visibleCols = e.component.getVisibleColumns();
        // for (const col in visibleCols) {
        //   const dataField = visibleCols[col].dataField;
        // }

        for (const col in re.data) {
          const val = re.data[col];
          e.component.cellValue(rowIndex, col, val);
          // instance.cellValue(rowIndex, col, val);
        }
        e.component.refresh();

        // e.component.saveEditData();
      }
    },

    async saveEditedDataToOData(key, newData, oldData) {
      try {
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };
        var data = {
          id: key,
          pegawai_id: oldData.pegawai_id,
          tgl_gaji: oldData.tgl_gaji,
          absen_bulan_id: oldData.absen_bulan_id,
          changes: newData,
          proyeksi: false,
        };
        const response = await axios.post(
          `${API_BASE_URL}/refresh_gaji_per_pegawai`,
          data,
          config
        );
        // You can access the response data using response.data
        if (response.data.status) {
          notify(response.data.message, "success");
          return response.data;
        } else {
          notify("Gagal update gaji pegawai", "error");
          return response.data;
        }
        // You can perform other operations here based on the response data
        // ...
      } catch (error) {
        // Handle the error appropriately
        console.error("Error:", error);
        notify("Gagal update gaji pegawai " + error, "error");
        return false; // If there was an error
      }
    },

    async saveEditedDataToOData2(key, newData, oldData) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var data = {
        id: key,
        pegawai_id: oldData.pegawai_id,
        tgl_gaji: oldData.tgl_gaji,
        absen_bulan_id: oldData.absen_bulan_id,
        changes: newData,
      };
      return await axios
        .post(`${API_BASE_URL}/refresh_gaji_per_pegawai`, data, config)
        .then((response) => {
          notify(response.data.message, "success");
        })
        .catch((error) => {
          console.log(error);
          notify("gagal update gaji", "error");
        });
    },
    oneditorpreparing: function (e) {
      if (e.parentType === "dataRow") {
        if (e.row.data.status_gaji) e.editorOptions.disabled = true;
        else {
          if (e.class == "noteditable") e.editorOptions.disabled = true;
        }
      }

      if (e.dataField === "tgl_gaji") {
        e.editorOptions.calendarOptions = {
          minZoomLevel: "year",
          maxZoomLevel: "year",
          displayFormat: "MM/yyyy",
          type: "month",
        };
      }
    },

    async approveAll(tab) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      var data = {};

      if (tab == "tDireksi") {
        data = {
          pegawai_status_id: 1,
          pegawai_status_nama: "Direksi",
        };
      } else if (tab == "tTetap") {
        data = {
          pegawai_status_id: 2,
          pegawai_status_nama: "Pegawai Tetap",
        };
      } else if (tab == "tHonor") {
        data = {
          pegawai_status_id: 3,
          pegawai_status_nama: "Pekerja Honor",
        };
      } else if (tab == "tKontrak") {
        data = {
          pegawai_status_id: 4,
          pegawai_status_nama: "Pekerja Kontrak",
        };
      }

      await axios
        .post(`${API_BASE_URL}/gaji_approve_all`, data, config)
        .then((response) => {
          notify(response.data.message, "success");
          if (tab == "tDireksi") this.dataSourceDireksi.reload();
          if (tab == "tTetap") this.dataSourceTetap.reload();
          if (tab == "tHonor") this.dataSourceHonor.reload();
          if (tab == "tKontrak") this.dataSourceKontrak.reload();
        })
        .catch((error) => {
          console.log(error);
          notify("Gagal approve gaji", "error");
        });
    },

    approveAllDialog(tab) {
      let result = confirm("<i>Approve semua gaji?</i>", "Konfirmasi");
      result.then((dialogResult) => {
        if (dialogResult) {
          this.approveAll(tab);
        }
      });
    },

    approveClick(e) {
      if (!this.can("gaji-approve")) return 0;
      if (e.data.value) return 0;
      let result = confirm("<i>Approve gaji pegawai?</i>", "Konfirmasi");
      result.then((dialogResult) => {
        if (dialogResult) {
          if (this.approveGaji(e.data.data.id)) {
            e.data.data.status_gaji = true;
          }
        }
      });
    },
    async approveGaji(gajiId) {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "multipart/form-data",
        },
      };
      var data = {
        id: gajiId,
      };

      axios
        .post(`${API_BASE_URL}/gaji_approve`, data, config)
        .then((response) => {
          notify(response.data.message, "success");
          return true;
        })
        .catch((error) => {
          notify("Gagal approve gaji", "error");
          console.log(error);
          return false;
        });
    },
    formatStatusGaji(method, value) {
      if (value.data.data.status_gaji) {
        if (method == "icon") return "lock";
        if (method == "type") return "success";
        // this.statusButtonIcon = "lock";
        // this.statusButtonType = "success";
        // return "Approved";
      } else {
        if (method == "icon") return "edit";
        if (method == "type") return "danger";
      }

      // return "Draft";
      return;
    },
    formatNumber(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return value;
    },
    calculateDisplayMK(e) {
      const today = DateTime.fromISO(e.tgl_gaji);
      const date2 = DateTime.fromISO(e.riwayatGolongan.tgl_mulai_bekerja);

      return Math.floor(today.diff(date2, "years").years) + " tahun";
    },
    formatMasaKerja(e) {
      const today = DateTime.local().setLocale("id"); //TODO nyari masa kerja bukan dari tgl sekarang, melainkan tgl pembuatan gaji
      const date2 = DateTime.fromISO(e);
      return Math.floor(today.diff(date2, "years").years);
    },
    formatMonth(e) {
      const isoDateString = e.split("/").reverse().join("-") + "-01";
      const date = DateTime.fromISO(isoDateString).setLocale("id");

      return date.monthLong + " " + date.year;
    },
    onPageChanged(e, gridRef) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs[gridRef].instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Gaji");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Gaji " + this.tabSource[this.tabPanelIndex].text + ".xlsx"
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
